// import React from 'react'
import { ArrowForward, CalendarMonth, LocationCity } from '@mui/icons-material'
// import React from 'react'
import { useEffect, useState } from 'react'
import { Button, Card, Tabs, Tab } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getMembers } from '../../api/api'
import Events from './events'
import { updateMembers, updateMembersCategory } from '../../redux/slices/membersSlice'
const AllMembers = () => {
  const navigate = useNavigate();
  const [newsStart, setNewsStart] = useState(0);
  const [newsEnd, setNewsEnd] = useState(5);
  const dispatch = useDispatch();
  const members = useSelector(state=> state.members.members);
  const membersCategory = useSelector(state => state.members.membersCategory);

  const fetchMembers = async () => {
    const response = await getMembers();
    console.log(response)
    if(response.success){
      dispatch(updateMembers(response.data));
    }
  }
//   const fetchTitleMenCategories = () => {
//     dispatch(updateMembersCategory([
//       {
//           unit: 'excos',
//           header: "EXCOS",
//           members: members.filter((member) => member.position.toLowerCase() !== 'member')
//       },
//       {
//           unit: 'badminton',
//           header: "Banminton Unit",
//           members: members.filter((member) => member.unit.toLowerCase() === 'badminton')
//       },
//       {
//           unit: 'gym',
//           header: "Gym Unit",
//           members: members.filter((member) => member.unit.toLowerCase() === 'gym')
//       },
//       {
//         unit: 'table_tennis',
//         header: "Table Tennis Unit",
//         members: members.filter((member) => member.unit.toLowerCase() === 'table_tennis')
//     },
//     {
//         unit: 'tennis',
//         header: "Tennis Unit",
//         members: members.filter((member) => member.unit.toLowerCase() === 'tennis')
//     },
// ]))
//   }

  useEffect(() => {
    // console.log(titleMen)
    // fetchTitleMenCategories();
    
  }, [members])
  useEffect(() => {
    // console.log(titleMenCategories);
    // console.log(titleMen)
  }, [])
  useEffect(() => {
    console.log(members);
    members.length === 0 && fetchMembers()
  }, [])

//   return (
//     <div>
//           <div className='row m-1'>
//           <div className='col-sm-12 col-xs-12 col-md-8 col-lg-8 col-xl-8'>
//           <Tabs
//               variant='tabs'
//               defaultActiveKey="bida"
//               id=""
//               className="mb-3"
              
//             >
//               {
//                 membersCategory.map((titleman, index) => {

//                   return (
//                           <Tab eventKey={titleman.city.toLowerCase()} title={<p className='news-title text-muted'>{titleman.city}</p>}
//                             className='bg-light tab'
//                             >
//                             <div className=''>
//                               {/* <h className='small-header ms-4 mt-4'> BIDA TITLE MEN </h> */}
//                               <p className='small-header ms-3'> {titleman.header} </p>
//                               {
//                                 titleman.titleMen.slice(newsStart,newsEnd).map((title, i) => {
//                                   return (
//                                     <Card className='m-3 title-men'
//                                     onClick={() => navigate(`/view-titleman?${titleman.city},${title.id}`)}
//                                     >
//                                         <div className=' row'
//                                         >
//                                           <div className=' col-sm-6 col-md-4 col-lg-4 col-xl-4'>
//                                             <img src={title.img} alt='title IMAGE'
//                                             className='w-100'
//                                             height={120}
//                                             />
//                                           </div>
//                                           <div className='col-sm-6 col-md-8 col-lg-8 col-xl-8 d-flex align-items-end'>
//                                             <span>
//                                               <h className='title-men-name'> {title.name}</h>
//                                               <p className='title-men-title'> {title.title}</p>
//                                               <p className='title-men-title text-muted'>Salutation: {title.salutation}</p>

//                                             </span>
//                                           </div>
//                                       </div>
//                                     </Card>
//                                   )
//                                 })
//                               }
//                               <div className='d-flex justify-content-center'>
//                               <Button
//                                 onClick={() => {
                                  
//                                   setNewsStart(newsStart - 5);
//                                   setNewsEnd(newsEnd - 5);
//                                 }}
//                                 disabled={newsStart == 0 && true}
//                                 size='sm' variant='outline-light' className=' read-btn'
//                                 style={{ 
//                                   width: '100px',
//                                   height: 40
//                                 }}
//                                 > Previous </Button>
//                                 <h1 className='mx-3 text-muted '>...</h1>
//                                 <Button  
//                                 onClick={() => {
//                                   setNewsStart(newsEnd);
//                                   setNewsEnd(newsEnd + 5);
                                  
//                                 }}
//                                 disabled={newsEnd >= titleman.titleMen.length && true}
//                                 variant='outline-light' className='read-btn'
//                                 style={{ 
//                                   width: '100px',
//                                   height: 40
//                                 }}
//                                 > More </Button>
//                               </div>
//                             </div>
//                             </Tab>
//                   )
//                 })
//               }
              
//             </Tabs>
//             <Events />
//           </div>
//           <div className='col-sm-12 col-xs-12 col-md-4 col-lg-4 col-xl-4'>
//             {/* <SideEvents /> */}
//             {/* <MediaLink /> */}
            
//           </div>
//       </div>
//     </div>
//   )
}

export default AllMembers
